import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { profile } from '../mock';
import useScrolled from '../hooks/useScrolled';
import { DesktopNav, MobileNav } from './header/Nav';

function Logo() {
  return (
    <a href="#top" className="flex items-center gap-3">
      <span className="relative w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden ring-1 ring-orange-acc/40 shrink-0">
        <img
          src="/portfolio/sc-logo.jpg"
          alt="SC monogram"
          className="w-full h-full object-cover scale-[1.02]"
        />
      </span>
      <span className="hidden md:inline text-[11px] uppercase tracking-[0.3em] text-cream-soft/70">
        {profile.year}
      </span>
    </a>
  );
}

export default function Header() {
  const scrolled = useScrolled(30);
  const [open, setOpen] = useState(false);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-navy/85 backdrop-blur-md border-b border-cream' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-4 md:py-5 flex items-center justify-between">
        <Logo />
        <DesktopNav />
        <a
          href="#contact"
          className="hidden md:inline-flex items-center gap-2 btn-orange px-5 py-2.5 text-xs uppercase tracking-[0.2em] rounded-full"
        >
          Say hello
        </a>
        <button className="md:hidden text-cream" onClick={() => setOpen((v) => !v)} aria-label="menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && <MobileNav onClose={() => setOpen(false)} />}
    </header>
  );
}
